export default __webpack_public_path__ + "static/for_sharing-de788ad03592a981948422b5933fe561.jpg";